(() => {
  const STEP_TRIGGER_RATIO = 0.75;

  const setActive = (root, index) => {
    const steps = Array.from(root.querySelectorAll('[data-nano-feedback-step]'));
    const images = Array.from(root.querySelectorAll('[data-nano-feedback-image]'));
    const maxIndex = Math.max(steps.length - 1, 0);
    const activeIndex = Math.min(Math.max(index, 0), maxIndex);

    steps.forEach((step, stepIndex) => {
      const isActive = stepIndex === activeIndex;
      const isRevealed = stepIndex <= activeIndex;
      step.classList.toggle('is-active', isActive);
      step.classList.toggle('is-revealed', isRevealed);
      step.setAttribute('aria-expanded', String(isRevealed));
    });

    images.forEach((image, imageIndex) => {
      image.classList.toggle('is-active', imageIndex === activeIndex);
    });

    root._nanoFeedbackIndex = activeIndex;
  };

  const getScrollDirection = (root) => {
    const scrollY = window.scrollY || window.pageYOffset || 0;
    const previousScrollY = root._nanoFeedbackScrollY ?? scrollY;
    root._nanoFeedbackScrollY = scrollY;
    return scrollY >= previousScrollY ? 'down' : 'up';
  };

  const getStepPoint = (step) => {
    const number = step.querySelector('.nano-feedback__number') || step;
    const rect = number.getBoundingClientRect();
    return rect.top + rect.height / 2;
  };

  const getScrollIndex = (root, steps, direction) => {
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    const rootRect = root.getBoundingClientRect();
    const maxIndex = steps.length - 1;

    if (rootRect.top >= viewportHeight) return 0;
    if (rootRect.bottom <= 0) return maxIndex;

    const triggerY = viewportHeight * STEP_TRIGGER_RATIO;
    let index = direction === 'up' ? maxIndex : 0;

    if (direction === 'up') {
      for (let stepIndex = steps.length - 1; stepIndex >= 0; stepIndex -= 1) {
        if (getStepPoint(steps[stepIndex]) <= triggerY) return stepIndex;
      }

      return 0;
    }

    steps.forEach((step, stepIndex) => {
      if (getStepPoint(step) <= triggerY) index = stepIndex;
    });

    return index;
  };

  const initFeedback = (root) => {
    if (root.dataset.nanoFeedbackReady === 'true') return;
    root.dataset.nanoFeedbackReady = 'true';

    const steps = Array.from(root.querySelectorAll('[data-nano-feedback-step]'));
    if (steps.length === 0) return;

    let ticking = false;

    steps.forEach((step, index) => {
      step.addEventListener('click', () => {
        setActive(root, index);
      });
    });

    const updateActiveStep = () => {
      const direction = getScrollDirection(root);
      setActive(root, getScrollIndex(root, steps, direction));
    };

    const requestActivation = () => {
      if (ticking) return;
      ticking = true;

      window.requestAnimationFrame(() => {
        ticking = false;
        updateActiveStep();
      });
    };

    /*
    // ── GSAP pin implementation (desktop) ─────────────────────────────────────
    const STEP_SCROLL_DISTANCE = 240;
    let trigger = null;

    const scrollToStep = (index) => {
      if (!trigger) { setActive(root, index); return; }
      const maxIndex = steps.length - 1;
      const progress = maxIndex > 0 ? index / maxIndex : 0;
      const start = Number(trigger.start) || window.scrollY + root.getBoundingClientRect().top;
      const end = Number(trigger.end) || start;
      window.scrollTo({ top: start + (end - start) * progress, behavior: 'smooth' });
    };

    const initDesktop = () => {
      if (!window.gsap || !window.ScrollTrigger || mediaQuery.matches) return;
      window.gsap.registerPlugin(window.ScrollTrigger);
      const stickyEl = root.querySelector('.nano-feedback__sticky');
      const scrollDistance = STEP_SCROLL_DISTANCE * Math.max(steps.length - 1, 1);
      const stickyHeight = stickyEl ? stickyEl.getBoundingClientRect().height : 0;
      root.style.minHeight = `${stickyHeight + scrollDistance}px`;
      trigger = window.ScrollTrigger.create({
        trigger: stickyEl,
        pin: stickyEl,
        pinSpacing: false,
        start: 'center center',
        end: () => `+=${scrollDistance}`,
        scrub: true,
        invalidateOnRefresh: true,
        onRefresh: () => {
          if (!stickyEl) return;
          root.style.minHeight = `${stickyEl.getBoundingClientRect().height + scrollDistance}px`;
        },
        onUpdate: (self) => {
          const maxIndex = steps.length - 1;
          setActive(root, Math.min(maxIndex, Math.round(self.progress * maxIndex)));
        },
      });
      window.ScrollTrigger.refresh();
    };

    const teardownDesktop = () => {
      if (!trigger) return;
      trigger.kill(true);
      trigger = null;
      root.style.minHeight = '';
      const stickyEl = root.querySelector('.nano-feedback__sticky');
      if (stickyEl) stickyEl.removeAttribute('style');
      setActive(root, 0);
    };

    const syncMode = () => {
      teardownDesktop();
      if (mediaQuery.matches) { requestActivation(); } else { initDesktop(); }
    };
    // ── end GSAP pin ──────────────────────────────────────────────────────────
    */

    window.addEventListener('scroll', requestActivation, { passive: true });
    window.addEventListener('resize', requestActivation);

    root._nanoFeedbackScrollY = window.scrollY || window.pageYOffset || 0;
    setActive(root, 0);
    requestActivation();
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-nano-feedback]').forEach(initFeedback);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
